/**
 * Returns an object containing all query string params as keys and values.
 * If multiple values for the same key are in the string, it will only
 * return the last one in the map.
 */
export const getQueryParams = (query = window.location.search) =>
  Object.fromEntries(new URLSearchParams(query).entries());
